"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const locales_1 = __importDefault(require("../enums/locales"));
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const model_scopes_1 = __importDefault(require("../enums/model-scopes"));
const GraphandFieldNumber_1 = __importDefault(require("../lib/fields/GraphandFieldNumber"));
const GraphandFieldRelation_1 = __importDefault(require("../lib/fields/GraphandFieldRelation"));
const GraphandFieldText_1 = __importDefault(require("../lib/fields/GraphandFieldText"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
/**
 * @class Project
 * @augments GraphandModel
 * @classdesc Project model. Use {@link GraphandClient#getModel client.getModel("Project")} to use this model
 */
class Project extends GraphandModel_1.default {
    /**
     * Returns current project
     * @returns {Project|GraphandModelPromise<Project>}
     */
    static getCurrent() {
        const client = this._client;
        return this.get(client._options.project);
    }
}
Project._customFields = {};
Project.apiIdentifier = "projects";
Project.baseUrl = "/projects";
Project.isGlobal = true;
Project.scope = model_scopes_1.default.Project;
Project.envScope = model_env_scopes_1.default.GLOBAL;
Project.schema = {
    name: new GraphandFieldText_1.default(),
    slug: new GraphandFieldText_1.default(),
    locales: new GraphandFieldText_1.default({ multiple: true, options: Object.values(locales_1.default) }),
    defaultLocale: new GraphandFieldText_1.default({ options: Object.values(locales_1.default) }),
    defaultRegisterRole: new GraphandFieldRelation_1.default({ ref: "Role", multiple: false }),
    accessTokenLifetime: new GraphandFieldNumber_1.default(),
    refreshTokenLifetime: new GraphandFieldNumber_1.default(),
    organization: new GraphandFieldRelation_1.default({ ref: "Organization", multiple: false }),
    owner: new GraphandFieldRelation_1.default({ ref: "Account", multiple: false }),
};
exports.default = Project;
